import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { WebService } from '../services/web.service';

@Injectable({
  providedIn: 'root'
})
export class CourseService {
  courseList: any=[];
  constructor(
    private webapi: WebService,
   
) { }
  getCourses() {
    return new Promise((resolve, reject) => {
        this.webapi.requestJson('getCourse', null) 
        .subscribe(
            data => {
                let response = JSON.parse(data.body);
                this.courseList = [...response.data];
                resolve(true)
            },
            error => {
                return(true)
            }
        )
    })
  }


}